
export const WORKPATH = '/workbench/workbench'
window.WORKPATH = WORKPATH

export function getWORKPATHDefaultData() {
  return ''
}
